import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { getAllActivities } from '../routines'

const {
  REQUEST,
  SUCCESS,
  FAILURE,
  FULFILL
} = getAllActivities

export const results = handleActions({
  // FIXME: redux saga routine promise should return success action
  // we do without payload that means that it should not fetch again
  // and the state is correct
  [SUCCESS]: (state, { payload }) => payload ? [...payload.result.response] : state,
  [FAILURE]: () => []
}, [])

export const requesting = handleActions({
  [REQUEST]: () => true,
  [FULFILL]: () => false
}, false)

export const error = handleActions({
  [SUCCESS]: () => null,
  [FAILURE]: (state, { payload }) => payload
}, null)

export default combineReducers({
  results,
  requesting,
  error
})
